module.exports = __webpack_public_path__ + "static/img/left.29380b7e.png";